/** 待付款 */
export const unpay = '10';
/** 待发货 */
export const toDeliver = '20';
/** 发货中 */
export const delivering = '30';
// DELIVERING("30","发货中"),
/** 待收货 */
export const pendingReceipt = '40';
// PENDING_RECEIPT("40","待收货"),
/** 待评价 */
export const comment = '50';
// COMMENT("50","交易成功"),
/** 已关闭 */
export const closed = '60';
// CLOSED("60","交易关闭"),
/** 已评价 */
export const completde = '70';
// COMPLETED("70","交易成功");
